/**
 * Common API
 *
 * @author jaehyub.lee@emcast.com
*/

import httpService from "@/api/httpService";

const commonApi = {
    // Server UTC Time
    getUTCTime() {
        return httpService.get(`/external/time/utc`);
    }
}

export default commonApi;